import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function fetchOpcoes() {
  const base = getBase();
  if (!base) return null;
  try {
    const res = await axios.get(base + '/automacoes/opcoes', { headers: getAuthHeaders(), timeout: 15000 });
    return res?.data ?? null;
  } catch (err) { return null; }
}

export async function fetchAutomacoes() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/automacoes', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    if (err?.response?.status === 501) return [];
    return [];
  }
}

export async function createAutomacao(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/automacoes', body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function updateAutomacao(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/automacoes/' + id, body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function deleteAutomacao(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/automacoes/' + id, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function fetchExecucoes(id) {
  const base = getBase();
  if (!base || !id) return [];
  try {
    const res = await axios.get(base + '/automacoes/' + id + '/execucoes', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) { return []; }
}

export function parseJSON(v, fallback) {
  if (v == null) return fallback;
  if (typeof v === 'object') return v;
  try { return JSON.parse(v); } catch (_) { return fallback; }
}
